<template>
  <div>
    <div class="container" v-if="Items && Items.length > 0">
      <div class="row">
        <div class="col-12">
          <!-- start product table -->
          <div class="checkout-table">
            <table class="products_table">
              <thead class="center">
              <tr>
                <th>حذف</th>
                <th>محصول</th>
                <th>قیمت واحد</th>
                <th>تعداد</th>
                <th>وزن</th>
                <th>مجموع</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in Items" :key="index">
                <td class="remove" data-title='حذف '>
                  <div class="product-remove">
                    <a @click="Remove(index)" href="#" class="close-btn close-dark">
                      <span></span>
                      <span></span>
                    </a>
                  </div>
                </td>
                <td data-title='محصول ' class="toltip">
                  <a :href="`https://henzagold.shop/product/${item.product.title.split(' ').join('-')}/${item.pid}`"
                     target="_blank">
                    <span class="toltiptext" v-if="getVariant(Items[index]).is_pre_order"> این محصول به صورت پیش فروش است </span>
                    <div class="product-box">
                      <img :src="Items[index].product.image.image" alt="product">
                      <div class="product-name">
                        <h6>
                          {{ Items[index].product.title }}
                        </h6>
                      </div>
                    </div>
                  </a>
                </td>
                <td class="center" data-title='قیمت واحد '>
                  <div v-if="showBeforePrice(item)" class="line-through mb-2">
                    {{ getVariant(Items[index]).price | priceUnit }}
                  </div>
                  <div>
                    <strong class="product-price">{{  getVariant(Items[index]).price_with_discount | priceUnit }}</strong>
                  </div>
                </td>
                <td data-title='تعداد '>
                  <div class="qty-box d-flex ltr">
                    <numberCounter
                        :min="1"
                        :max="(getVariant(Items[index]).qty > 0)?getVariant(Items[index]).qty:Infinity"
                        :number="item.qty"
                        @input="updateItemQuantity($event,index)" class="inline-flex"/>
                  </div>
                </td>
                <td class="center" data-title='وزن '>
                  <strong>{{ getVariant(Items[index]).title }}</strong>
                </td>
                <td class="center" data-title='مجموع '>
                  <div v-if="showBeforePrice(item)" class="line-through mb-2">
                    {{ getVariant(Items[index]).price * Items[index].qty | priceUnit }}
                  </div>
                  <div>
                    <strong class="product-price">{{  getVariant(Items[index]).price_with_discount * Items[index].qty | priceUnit }}</strong>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- end product table -->
          <!-- strat Addresses -->
          <div class="coupen-code-wrapper rounded-8">
            <h4>آدرس</h4>
            <label v-if="Addresses">آدرس خود را انتخاب کنید</label>
            <ul class="nav nav-tabs tab-cards" id="submitProductTab" role="tablist">
              <li class="nav-item" v-for="( Item , Address ) in Addresses" :key="Address">
                <div @click="Check_Index(Address)" :class="`${Find_style(Address)} flex items-center`"
                     class="nav-link" id="basic-info-tab" data-toggle="tab" href="#basic-info" role="tab"
                     aria-controls="basic-info" aria-selected="true">
                  <div class="flex-1">
                    {{ Addresses[Address].province }} ، {{ Addresses[Address].city }} ،
                    {{ Addresses[Address].address.substring(0, 20) }}
                    <span class="sp" v-if="Addresses[Address].address.length > 16"> ...</span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="flex items-center justify-center">
              <button class="btn-custom secondary" @click="addressModel = true">افزودن آدرس جدید</button>
            </div>
          </div>
          <div class="coupen-code-wrapper rounded-8">
            <h4 style="font-size: 24px;margin-bottom: 0.3em;">گزینه های پرداختی</h4>

            <p class="custom-sub-title" style="margin-top: 10px;">برای استفاده از کیف پول گزینه ی آن را فعال کنید</p>
            <hr>
            <div class="mb-4 row">
              <span style="width: 46px;height: 46px;background: #e5e5e563;"
                    class="ml-2 rounded-8 justify-content-center flex align-items-center">
                <Icon icon="ion:wallet-outline" style="font-size: 30px;color: var(--primary-color)"/>
              </span>
              <div class="flex p-0">
                <div class="ml-4 flex flex-column justify-content-between">
                  <div> کیف پول</div>
                  <span class="custom-sub-title">مانده نقدی در هر خرید قابل استفاده است</span>
                </div>
              </div>
              <div class="row p-0 flex-1 justify-content-between">
                <div class="col-6 flex flex-column justify-content-between p-0">
                  <div class="custom-sub-title" style="font-size: 1em"> موجودی :</div>
                  <div>
                    <span class="ml-2" style="color: var(--primary-color)">{{ goldWalletPrice |price }}</span>
                    <span style="font-size: .9rem;color:#b1b1b1 ">تومان</span>
                  </div>
                </div>
                <div class="flex align-items-center">
                  <vs-switch class="col-6" v-model="use_wallet" color="var(--primary-color)"></vs-switch>
                </div>
              </div>
            </div>
          </div>
          <!-- end Addresses -->
        </div>
        <div class="col-xl-8 col-12">
          <div class="coupen-code-wrapper rounded-8 font-size-1">
            <div class="flex justify-content-between mb-3">
              <div class="title">جمع کل مبلغ خرید</div>
              <div class="value">{{ price | priceUnit }}</div>
            </div>
            <div class="flex justify-content-between mb-3">
              <div class="title">تخفیف</div>
              <div class="value">{{ totalDiscount | priceUnit }}</div>
            </div>
            <div class="flex justify-content-between mb-3">
              <div class="title">کیف پول</div>
              <div class="value">
                {{ (use_wallet ? Math.min(goldWalletPrice, Total) : 0) |priceUnit }}
              </div>
            </div>
            <vs-divider/>
            <div class="flex justify-content-between">
              <div class="title">مبلغ قابل پرداخت</div>
              <div class="value">{{ showPrice | priceUnit }}</div>
            </div>
          </div>
          <button @click="Submit_Order" class="btn-custom secondary btn-block">ثبت سفارش</button>
        </div>
<!--        <div class="offset-xl-6 col-xl-6">
          <div class="cart-total checkout-table">
            &lt;!&ndash; start price table &ndash;&gt;
            <h4>مجموع</h4>
            <table class="single-row-table">
              <tbody>
              <tr>
                <th>مجموع</th>
                <td>
                  <strong>{{ Total | priceUnit }}</strong>
                </td>
              </tr>
              </tbody>
            </table>
            &lt;!&ndash; end price table &ndash;&gt;
            <button @click="Submit_Order" class="btn-custom secondary btn-block">ثبت سفارش</button>
          </div>
        </div>-->
      </div>
      <modal v-model="addressModel" @close="clear">
        <template v-slot:header>
          افزودن آدرس جدید
        </template>
        <template v-slot:body>
          <form @submit.prevent="beforeAdd_Address">
            <div class="row">
              <div class="col-lg-4 form-group">
                <label>نام و نام خانوادگی دریافت کننده</label>
                <input v-model="Form_Data.reciver_fname" type="text" class="form-control"
                       placeholder="نام و نام خانوادگی دریافت کننده" v-validate="{required: true, fa: true}"
                       name="fullname">
                <div class="text-danger text-sm" v-for="error in errors.collect('fullname')" :key="error">{{
                    error
                  }}
                </div>
              </div>
              <div class="col-lg-4 form-group">
                <label>استان</label>
                <input v-model="Form_Data.province" type="text" class="form-control" placeholder="استان"
                       v-validate="{required: true, fa: true}" name="state">
                <div class="text-danger text-sm" v-for="error in errors.collect('state')" :key="error">{{ error }}</div>
              </div>
              <div class="col-lg-4 form-group">
                <label>شهر</label>
                <input v-model="Form_Data.city" type="text" class="form-control" placeholder="شهر"
                       v-validate="{required: true, fa: true}" name="city">
                <div class="text-danger text-sm" v-for="error in errors.collect('city')" :key="error">{{ error }}</div>
              </div>
              <div class="col-lg-4 form-group">
                <label>کد پستی</label>
                <input v-model="Form_Data.zipcode" type="Phone" class="form-control" placeholder=" xxxxxxxxxx "
                       v-validate="{required: true, numeric: true,min:10,max:10}" name="zip" @keypress="onlyNumber">
                <div class="text-danger text-sm" v-for="error in errors.collect('zip')" :key="error">{{ error }}</div>
              </div>
              <div class="col-lg-4 form-group">
                <label>شماره تلفن همراه</label>
                <input v-model="Form_Data.reciver_phone" type="text" class="form-control" placeholder=" 09xxxxxxxxx "
                       v-validate="{required: true, mobile: true}" name="mobile" @keypress="onlyNumber">
                <div class="text-danger text-sm" v-for="error in errors.collect('mobile')" :key="error">{{
                    error
                  }}
                </div>
              </div>
              <div class="col-lg-4 form-group">
                <label> تلفن ثابت</label>
                <input v-model="Form_Data.reciver_fixed_phone" type="text" class="form-control"
                       placeholder=" 0x1xxxxxxx " v-validate="{required: true, phone: true}" name="phone"
                       @keypress="onlyNumber">
                <div class="text-danger text-sm" v-for="error in errors.collect('phone')" :key="error">{{ error }}</div>
              </div>
              <div class="col-md-12 form-group">
                <label>آدرس</label>
                <textarea v-model="Form_Data.address" class="form-control" placeholder="آدرس کامل" rows="4"
                          v-validate="{required: true}" name="address"/>
                <div class="text-danger text-sm" v-for="error in errors.collect('address')" :key="error">{{
                    error
                  }}
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center">
              <button @click.prevent="beforeAdd_Address" class="btn-custom secondary"> ثبت آدرس</button>
            </div>
          </form>
        </template>
      </modal>
    </div>
    <h2 class="text-center" style="margin-top: 50px;" v-if="!$store.state.cart.items ||($store.state.cart.items && $store.state.cart.items.length<1)">هیچ محصولی در سبد خرید ندارید</h2>
    <modal :maxWidth="'500px'" v-model="endModel" @close="$router.push('/my-orders')">
      <template v-slot:header>
        سفارش با موفقیت ثبت شد
      </template>
      <template v-slot:body>
        <p style="text-align: center;font-size: 17px">لطفا منتظر تماس کارشناس فروش ما باشید</p>
      </template>
    </modal>
  </div>
</template>

<script>
import axios from '@/plugins/axios'
import modal from '@/components/modal.vue'
import numberCounter from "@/components/numberCounter";
import {Icon} from "@iconify/vue2"

export default {
  props: {
    togglePreLoader: Function
  },
  components: {
    modal,
    Icon,
    numberCounter
  },
  data() {
    return {
      use_wallet: false,
      wallet: {
        credit: null,
        gold_toman: null,
      },
      use_credit: false,
      Addresses: [],
      Address_Id: null,
      Form_Data: {
        reciver_fname: null,
        province: null,
        city: null,
        address: null,
        reciver_phone: null,
        reciver_fixed_phone: null,
        zipcode: null,
        new: null,
        is_default: 1
      },
      Data: null,
      shippingAddress: undefined,
      addressModel: false,
      endModel: false,
    }
  },
  methods: {
    async getWallet() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios.get("/cu/customer/wallet")
        this.wallet = data
      }
      catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for(let item of Object.values(error.response.data.errors))
          {
            item.map(xx=>{
              if (xx.includes("shipping address")){
                str_error += xx.replace("shipping address","آدرس") + "<br/>"
              }
              else{
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
        }
        else{
          if (error) {
            if(error == "Error: Network Error"){
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
            }
            else {
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
            }
          }
        }
      }
      finally{
        this.togglePreLoader('close')
      }
    },
    showBeforePrice(item) {
      const variant = this.getVariant(item)
      if (variant.price === variant.price_with_discount) {
        return false
      } else {
        return true
      }
    },
    getVariant(product){
      const variants = product.product.variants.filter(x=>x.id === product.vid)
      if(variants && variants.length)
        return variants[0]
      return undefined
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault();
      }
    },
    clear() {
      this.Form_Data = {
        reciver_fname: null,
        province: null,
        city: null,
        address: null,
        reciver_phone: null,
        reciver_fixed_phone: null,
        zipcode: null,
        new: null,
        is_default: 1
      }
    },
    updateItemQuantity(event, index) {
      this.$store.dispatch("cart/updateItemQuantity", {quantity: event, index})
    },
    Remove(index) {
      this.$store.dispatch('cart/remove', this.Items[index]);
    },
    Check_Index(Index) {
      this.Address_Id = Index
      this.shippingAddress = this.Addresses[Index]
    },
    Find_style(Index) {
      return (Index == this.Address_Id) ? 'active' : ''
    },
    async Get_Addresses() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios.get(`/cu/address`)
        this.Addresses = data
        this.Address_Id = data.findIndex(Address => Address.is_default !== 0)
        this.shippingAddress = data.filter(Address => Address.is_default !== 0)[0]
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
    async Submit_Order() {
      try {
        this.togglePreLoader('open')
        if (!this.Addresses || !this.shippingAddress) {
          throw 'وارد کردن آدرس الزامی است';
        }
        let order_items = []
        for (let x of this.Items) {
          let y = {
            title: x.title,
            price: this.getVariant(x).price_with_discount * x.qty,
            qty: x.qty,
            product_id: x.pid,
            variant_id: x.vid,
            grams: this.getVariant(x).grams,
            rial_pay: this.getVariant(x).rial_pay,
            variant_title: this.getVariant(x).title,
            is_preorder: this.getVariant(x).is_pre_order,
            total_discount: x.qty*(this.getVariant(x).price - this.getVariant(x).price_with_discount),
            total_price: this.getVariant(x).price * x.qty,
            promotion_id: x.promotion_id,
          }
          order_items.push(y)
        }
        await axios({
          method: 'post',
          url: '/cu/order',
          headers: {},
          data: {
            app: "web",
            order_items,
            shipping_address: this.shippingAddress,
            total_price: this.Total,
            sts: 1,
            total_discount: this.totalDiscount,
            price: this.price,
            total_weight: this.totalWeight,
            gold_price_original: parseInt(this.$store.state.config.price.geram18.p.split(',').join('')),
            use_wallet: this.use_wallet,
          }
        })
        this.endModel = true
        this.$store.dispatch('cart/clear');
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    },
    beforeAdd_Address() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.Add_Address()
          return;
        }

        this.$vs.notify({
          title: 'خطا',
          text: "مقادیر ورودی نا معتبراست",
          color: 'danger'
        })
      });
    },
    async Add_Address() {
      try {
        this.togglePreLoader('open')
        let {data} = await axios({
          method: 'post',
          url: `/cu/address`,
          headers: {},
          data: this.Form_Data
        })
        this.Data = data
        this.addressModel = false
        this.Get_Addresses()
        this.$vs.notify({
          time: 3500,
          text: 'اطلاعات با موفقیت ویرایش شد',
          color: 'var(--secondary-color)',
          icon: 'check'
        })
      } catch (error) {
        if (error.response && error.response.data.errors) {
          let str_error = ''
          for (let item of Object.values(error.response.data.errors)) {
            item.map(xx => {
              if (xx.includes("shipping address")) {
                str_error += xx.replace("shipping address", "آدرس") + "<br/>"
              } else {
                str_error += xx + "<br/>"
              }
            })
          }
          this.$vs.notify({
            title: 'خطایی رخ داد',
            time: 3500,
            text: str_error,
            color: 'var(--secondary-color)',
            icon: 'error_outline'
          })
        } else {
          if (error) {
            if (error == "Error: Network Error") {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: "اتصال برقرار نشد",
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            } else {
              this.$vs.notify({
                title: 'خطایی رخ داد',
                time: 3500,
                text: error,
                color: 'var(--secondary-color)',
                icon: 'error_outline'
              })
            }
          }
        }
      } finally {
        this.togglePreLoader('close')
      }
    }
  },
  computed: {
    showPrice() {
      if (this.use_wallet) {
        if (this.goldWalletPrice < this.Total) return this.Total - this.goldWalletPrice
        return 0
      }
      return this.Total
    },
    goldWalletPrice() {
      return Math.floor(this.wallet.gold_toman + this.wallet.credit) || 0
    },
    Items() {
      return this.$store.state.cart.items
    },
    Total() {
      let Total = 0
      for (let Product of this.Items) {
        Total +=  this.getVariant(Product).price * Product.qty
      }
      return Total
    },
    price() {
      let Total = 0
      for (let Product of this.Items) {
        Total += (this.getVariant(Product).price_with_discount * Product.qty)
      }
      return Total
    },
    totalWeight() {
      let Total = 0
      for (let Product of this.Items) {
        Total += this.getVariant(Product).grams
      }
      return Total
    },
    totalDiscount() {
      let Total = 0
      for (let Product of this.Items) {
        Total += this.getVariant(Product).price - this.getVariant(Product).price_with_discount
      }
      return Total
    },
  },
  async beforeCreate(){
    await this.$store.dispatch("cart/init")
  },
  async created() {
    await this.getWallet()
    try {
      this.togglePreLoader('open')
      await this.Get_Addresses()
    } catch (error) {
      if (error.response && error.response.data.errors) {
        let str_error = ''
        for (let item of Object.values(error.response.data.errors)) {
          item.map(xx => {
            if (xx.includes("shipping address")) {
              str_error += xx.replace("shipping address", "آدرس") + "<br/>"
            } else {
              str_error += xx + "<br/>"
            }
          })
        }
        this.$vs.notify({
          title: 'خطایی رخ داد',
          time: 3500,
          text: str_error,
          color: 'var(--secondary-color)',
          icon: 'error_outline'
        })
      } else {
        if (error) {
          if (error == "Error: Network Error") {
            this.$vs.notify({
              title: 'خطایی رخ داد',
              time: 3500,
              text: "اتصال برقرار نشد",
              color: 'var(--secondary-color)',
              icon: 'error_outline'
            })
          } else {
            this.$vs.notify({
              title: 'خطایی رخ داد',
              time: 3500,
              text: error,
              color: 'var(--secondary-color)',
              icon: 'error_outline'
            })
          }
        }
      }
    } finally {
      this.togglePreLoader('close')
    }
  }
}
</script>

<style lang="css" scoped>
.qty-box .con-vs-tooltip span {
  height: 100% !important;
}

.ltr {
  direction: ltr;
  justify-content: center;
}

.nav-tabs.tab-cards .nav-link span {
  margin: 0 0 0 15px;
}

.nav-tabs .nav-link {
  margin-right: 0;
}

.sp {
  background-color: unset !important;
  color: unset !important;
  border: 0 !important;
  box-shadow: unset !important;
  margin: 0 !important;
  display: inline !important;
}
.line-through{
  text-decoration: line-through;
}

.custom-sub-title {
  font-size: .9rem;
  color: #b1b1b1;
}
.font-size-1, .font-size-1 *{
  font-size: 1.012em !important;
}
.title{
  margin-bottom: 0 !important;
}
</style>
